import type { Router } from 'vue-router'
import PAGE_NAME from '@web/consts/PAGE_NAME'
import type { ModalButton } from './types'

export interface ActionHandlers {
  openUrl: (url: string) => void
  assignUrl: (url: string) => void
  navigate: (path: string) => void
}

// deeplink на вебе — путь внутри ЛК (`/course/123/calendar`). Проверяем до показа.
export function isKnownRoute (router: Router, path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false
  try {
    const resolved = router.resolve(path)
    return resolved.matched.length > 0 && resolved.name !== PAGE_NAME.NOT_FOUND
  } catch {
    return false
  }
}

export function runAction (button: ModalButton, handlers: ActionHandlers): void {
  if (!button.payload) return
  switch (button.action) {
    case 'url':
      handlers.openUrl(button.payload)
      break
    case 'webview':
      // Аналог вебвью приложения — та же вкладка: так отрабатывает возврат с оплаты.
      handlers.assignUrl(button.payload)
      break
    case 'deeplink':
      handlers.navigate(button.payload)
      break
  }
}
